import React from 'react'
import './App.css'
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import {notification} from 'antd'


const StyledTableCell = withStyles((theme) => ({
	head: {
	  backgroundColor: theme.palette.common.black,
	  color: theme.palette.common.white,
	},
	body: {
	  fontSize: 14,
	},
  }))(TableCell);
  
  const StyledTableRow = withStyles((theme) => ({
	root: {
	  '&:nth-of-type(odd)': {
		backgroundColor: '#eceff1',
	  },
	}, hover: {
		'&:hover': {
			backgroundColor: '#e3f2fd !important'
		}
	}
  }))(TableRow);

  const openNotification1 = (message, placement="bottomRight") => {
	notification["error"]({
	  message: 'Prerequisite not met',
	  description:
		'You have not met the pre-requisites required for this course. Make sure you completed the pre-requisites before enrolling.',
	  placement,
	});
  };

class Subsection extends React.Component {

	render() {
		var rows = [];
		function generateSubsections(subSect, courseKey, addCartCourse, sectIdx, propsComp, propsReq) {
			var arr = [];
			// generate the time
			function stringifyTime(timeArray) {
				var timeArr = [];
				arr = Object.entries(timeArray);
				arr.map((t,idx) => {
					timeArr.push(<div key={idx}>{t[0].charAt(0).toUpperCase() + t[0].slice(1) + ": " + t[1]} <br></br></div>)
				})
				return timeArr;
			}

			subSect.map((sect, idx)=> {
				rows.push(
					<StyledTableRow 
						key={idx} 
						hover={true}
						onClick={()=> {
							var completed = propsComp;
							var reqs = propsReq;
							// var needToComplete = [];
						
							var allComplete = true;
							for(var i = 0; i < reqs.length; i++) {
							  var atLeastOne = false;
							  for(var j = 0; j < reqs[i].length; j++) {
								// preReq completed
								if(completed.includes(reqs[i][j])) {
								  atLeastOne = true;
								  break;
								}
								allComplete = false;
							  }
						
							  if(atLeastOne === false) {
								// suggest the user to complete at least one in the list
								// needToComplete.push(reqs[i]);
								openNotification1("hello world");
							  }
							}

							addCartCourse (
								{
								  course: courseKey,
								  section: sectIdx,
								  subsection: sect
								}
							  );
						}}>
						<StyledTableCell>{sect.number.replace('_',' ')}</StyledTableCell>
						<StyledTableCell></StyledTableCell>
						<StyledTableCell>{sect.location}</StyledTableCell>
						<StyledTableCell>{stringifyTime(sect.time)}</StyledTableCell>
					</StyledTableRow>
				)
			})

		}

		// actual return
		return (
			<React.Fragment>
				{rows}
				{generateSubsections(this.props.Section, this.props.courseKey, this.props.addCartCourse, this.props.sectIdx, this.props.completedCourses, this.props.data.requisites)}
			</React.Fragment>
		)
	}
}

export default Subsection;